import { DictLike } from "@/types/dict";
import request, { AxiosResponseBody } from ".";
import { PurchaseOrderItem, PurchaseOrderAddItem, SupplierPrice, SupplierPriceAdd, PurchaseOrderAdd, PurchaseOrder, PurchasePrintAdd, PurchasePrint, PurchaseOrderStateEnum, PurchasefFnishStateEnum, BatchInOrderAdd, PurchasefInStateEnum } from "@/types/purchase";
import { isString, isStringEmpty } from "@/utils/checkTool";
import { CommonListParams } from "@/types/common";
import { getStorage } from "@/utils/storage";
import { OrderItemV2, OrderV2 } from "@/types/inventoryV2";

const url = "/wms/purchase";
const orderUrl = `${url}/order`;
const orderItemUrl = `${orderUrl}/item`;

export type OrderItemUpdateKey =
  'orderState' | 'otherNumber1'
export type OrderUpdateKey =
  "receiver" | "receiverAddress" | "receiverContact" | "receiverMobile" | "acceptState"

const apis = {
  types: `${orderItemUrl}/types`,
  itemList: () => `${orderItemUrl}/list`,
  rePrint: (id: string) => `${orderUrl}/print/${id}/del`,
  itemZFList: `${orderItemUrl}/dels`,
  itemFetchs: () => `${orderItemUrl}/fetchs`,
  itemDel: (id: string) => `${orderItemUrl}/${id}/del`,
  itemAdd: (id: string) => `${orderUrl}/${id}/addItem`,
  itemUpdate: (id: string) => `${orderItemUrl}/${id}/update`,
  updateItemByKey: (id: string, key: OrderItemUpdateKey) => `${orderItemUrl}/${id}/${key}/update`,
  itemFetch: (id: string) => `${orderItemUrl}/${id}/fetch`,

  add: `${orderUrl}/add`,
  update: (id: string) => `${orderUrl}/${id}/update`,
  orderFetch: (id: string) => `${orderUrl}/${id}/fetch`,
  updateByKey: (id: string, key: OrderUpdateKey) => `${orderUrl}/${id}/${key}/update`,


  priceList: `${url}/price/list`,
  priceDel: (id: string) => `${url}/price/${id}/del`,
  priceFetch: (id: string) => `${url}/price/${id}/fetch`,
  priceUpdate: (id: string) => `${url}/price/${id}/update`,

  purchasePrint: `${orderUrl}/print/add`,
  purchaseFetch: (id: string) => `${orderItemUrl}/${id}/fetch`,
  purOrderInventories: (id: string) => `${orderItemUrl}/${id}/inventoryOrderItems`,

  // 更新finishState
  finishStateUpdate: (id: string) => `${orderUrl}/orderItem/${id}/finishState/update`,

  // 批量完结
  batchCompleteUpdate: `${orderUrl}/orderItem/finishState/updates`,

  //退换货
  hasReturn: `${orderItemUrl}/hasReturned/list`,

  batchInOrderAdd: `${orderUrl}/batchInOrder/add`,


};

export const types = () => {
  return request<Array<DictLike>, void>(apis.types)
    .then(({ body: info }) => Promise.resolve(info))
    .catch((err) => Promise.reject(err));
};

export enum PrintStateEnum {
  UN_PRINT = '0',
  PRINTED = '1'
}
export interface ItemListParams {
  supplierId: string;
  keyword: string;
  orderStates?: Array<PurchaseOrderStateEnum>;
  printState?: PrintStateEnum;
  finishState?: PurchasefFnishStateEnum;
  inState?: PurchasefInStateEnum;
  deliveryDeadline?: number;
  finishStates?: Array<PurchasefFnishStateEnum>;
  productIds?: Array<string>
}

export const itemList = (params?: CommonListParams<ItemListParams>) => {
  return new Promise<CommonListParams<Array<PurchaseOrderItem>>>((resolve, reject) => {
    request<Array<PurchaseOrderItem>, ItemListParams>(apis.itemList(), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const itemZFList = (params?: CommonListParams<ItemListParams>) => {
  return new Promise<CommonListParams<Array<PurchaseOrderItem>>>((resolve, reject) => {
    request<Array<PurchaseOrderItem>, ItemListParams>(apis.itemZFList, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const itemFetchs = (params?: CommonListParams<ItemListParams>) => {
  return new Promise<CommonListParams<Array<PurchaseOrderItem>>>((resolve, reject) => {
    request<Array<PurchaseOrderItem>, ItemListParams>(apis.itemFetchs(), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const itemFetch = (id: string) => {
  return new Promise<PurchaseOrderItem>((resolve, reject) => {
    if (!isString(id) || isStringEmpty(id)) {
      return Promise.reject(10012);
    }
    request<PurchaseOrderItem, string>(apis.itemFetch(id))
      .then(({ body: detail }) => resolve(detail))
      .catch((err) => reject(err));
  });
};

export const rePrint = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    if (!isString(id) || isStringEmpty(id)) {
      return reject(10012);
    }
    request<void, void>(apis.rePrint(id))
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};


export const itemDel = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    if (!isString(id) || isStringEmpty(id)) {
      return reject(10012);
    }
    request<void, void>(apis.itemDel(id))
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const itemAdd = (id: string, data: PurchaseOrderAddItem) => {
  return new Promise<PurchaseOrderItem>((resolve, reject) => {
    if (!isString(id) || isStringEmpty(id)) {
      return reject(10012);
    }
    request<PurchaseOrderItem, PurchaseOrderAddItem>(apis.itemAdd(id), {
      params: { body: data },
    })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const itemUpdate = (id: string, info: PurchaseOrderAddItem) => {
  return new Promise<void>((resolve, reject) => {
    if (!isString(id) || isStringEmpty(id)) {
      return reject(10012);
    }
    request<void, PurchaseOrderAddItem>(apis.itemUpdate(id), {
      params: { body: info },
    })
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export interface UpdateByKey<T,> {
  key: OrderItemUpdateKey;
  value: T;
}
export interface OrderUpdateByKey<T,> {
  key: OrderUpdateKey;
  value: T;
}
export const itemUpdateByKey = <T,>(id: string, props: UpdateByKey<T>) => {
  return new Promise<PurchaseOrderItem>((resolve, reject) => {
    if (
      (!isString(id) || isStringEmpty(id)) &&
      props.key &&
      !isString(props.key)
    ) {
      return reject(10012);
    }
    request<PurchaseOrderItem, T>(apis.updateItemByKey(id, props.key), {
      params: { body: props.value },
    })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};
export const orderUpdateByKey = <T,>(id: string, props: OrderUpdateByKey<T>) => {
  return new Promise<void>((resolve, reject) => {
    if (
      (!isString(id) || isStringEmpty(id)) &&
      props.key &&
      !isString(props.key)
    ) {
      return reject(10012);
    }
    request<void, T>(apis.updateByKey(id, props.key), {
      params: { body: props.value },
    })
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const add = (addInfo: PurchaseOrderAdd) => {
  return new Promise<PurchaseOrder>((resolve, reject) => {
    return request<PurchaseOrder, PurchaseOrderAdd>(apis.add, {
      params: { body: addInfo },
      requestConfig: { headers: { org_id: getStorage('curOrgId') } }
    })
      .then(res => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const update = (id: string, info: PurchaseOrderAdd) => {
  return new Promise<void>((resolve, reject) => {
    if (!isString(id) || isStringEmpty(id)) {
      return reject(10012);
    }
    request<void, PurchaseOrderAdd>(apis.update(id), {
      params: { body: info },
    })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const orderFetch = (id: string) => {
  return new Promise<PurchaseOrder>((resolve, reject) => {
    if (!isString(id) || isStringEmpty(id)) {
      return reject(10012);
    }
    request<PurchaseOrder, undefined>(apis.orderFetch(id))
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const priceList = (meaningStr: string, params?: CommonListParams<string>) => {
  return new Promise<AxiosResponseBody<Array<SupplierPrice>>>((resolve, reject) => {
    request<Array<SupplierPrice>, string>(apis.priceList, { params })
      .then(res => resolve(res))
      .catch(err => reject(err))
  })
};

export const priceDel = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, void>(apis.priceDel(id))
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const priceFetch = (id: string) => {
  return new Promise<SupplierPrice>((resolve, reject) => {
    request<SupplierPrice, void>(apis.priceFetch(id))
      .then(res => resolve(res.body))
      .catch(err => reject(err))
  })
};

export const priceUpdate = (id: string, info: SupplierPriceAdd) => {
  return new Promise<SupplierPrice>((resolve, reject) => {
    if (id && !isString(id)) {
      return reject(10012);
    }
    request<SupplierPrice, SupplierPriceAdd>(apis.priceUpdate(id), {
      params: { body: info },
    }).then(res => resolve(res.body)).catch(err => reject(err))
  });
};

export const purchasePrint = (info: PurchasePrintAdd) => {
  return new Promise<{ id: string }>((resolve, reject) => {
    request<{ id: string, }, PurchasePrintAdd>(apis.purchasePrint, {
      params: { body: info },
    }).then(res => resolve(res.body)).catch(err => reject(err))
  });
};

export const purchaseFetch = (id: string) => {
  return new Promise<PurchaseOrder>((resolve, reject) => {
    request<PurchaseOrder>(apis.purchaseFetch(id))
      .then(res => resolve(res.body)).catch(err => resolve(err))
  });
};

export const purOrderInventories = (id: string) => {
  return new Promise<Array<OrderItemV2>>((resolve, reject) => {
    request<Array<OrderItemV2>, string>(apis.purOrderInventories(id))
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const finishStateUpdate = (id: string, val: PurchasefFnishStateEnum | undefined) => {
  if (val === undefined || val === null) return Promise.reject(10086)
  return new Promise<void>((resolve, reject) => {
    request<void, PurchasefFnishStateEnum>(apis.finishStateUpdate(id), {
      params: { body: val }
    })
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const batchCompleteUpdate = (
  ids: string[],
  val: PurchasefFnishStateEnum | undefined
) => {
  if (val === undefined || val === null || ids.length === 0) {
    return Promise.reject(10086)
  }
  return new Promise<void>((resolve, reject) => {
    request<void, PurchasefFnishStateEnum>(apis.batchCompleteUpdate, {
      params: { body: val, strs: ids }
    })
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const hasReturn = (params?: CommonListParams<ItemListParams>) => {
  return new Promise<CommonListParams<Array<PurchaseOrderItem>>>((resolve, reject) => {
    request<Array<PurchaseOrderItem>, ItemListParams>(apis.hasReturn, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const batchInOrderAdd = (data: BatchInOrderAdd) => {
  return new Promise<any>((resolve, reject) => {
    request<any, BatchInOrderAdd>(apis.batchInOrderAdd, { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};



const exportObject = {
  types,
  priceDel,
  rePrint,
  priceFetch,
  priceUpdate,
  itemList,
  itemZFList,
  itemDel,
  itemAdd,
  itemUpdate,
  itemFetch,
  itemUpdateByKey,
  update,
  orderFetch,
  orderUpdateByKey,
  add,
  purchasePrint,
  purchaseFetch,
  itemFetchs,
  hasReturn
};

export default exportObject;
